module.exports = __webpack_public_path__ + "img/ayudantia_up.dd48df82.svg";